import React,{useState} from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import axios from 'axios'
import './authStyles.css'

export default function Signin() {
  const [email,setEmail]=useState('')
  const [password,setPassword]=useState('')
  const navigate=useNavigate()
  const handelSubmit=async(e)=>{
    e.preventDefault()
    let response=await axios.post('http://localhost:5000/signin',{email:email,password:password})
    document.cookie=`jwtoken=${response.data.token}`
    console.log(response)
    if(!response.status===200){
      navigate('/signin')
    }
    else{
      navigate('/')
    }
    

  }
  return (
    <div>
        <div>
       <div className="container">
      <div className="card">
        <div className="card_title">
          <h1>Welcome...</h1>
          <span>Please enter your creds</span>
        </div>
        <div className="form">
        <form onSubmit={handelSubmit}>
          <input type="email" name="email" placeholder="Email" id="email" value={email} onChange={(e)=>setEmail(e.target.value)} />
          <input type="password" name="password" placeholder="Password" id="password"  value={password} onChange={(e)=>setPassword(e.target.value)} />
          <button>Log in</button>
          </form>
        </div>
        <div className="card_terms">
            <span>New to the App...<Link to='/signup'>Signup</Link></span>
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}
